import { render, staticRenderFns } from "./application.vue?vue&type=template&id=3890d4e3&scoped=true&"
import script from "./application.vue?vue&type=script&lang=js&"
export * from "./application.vue?vue&type=script&lang=js&"
import style0 from "./application.vue?vue&type=style&index=0&id=3890d4e3&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./application.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3890d4e3",
  null
  
)

export default component.exports